export default __webpack_public_path__ + "static/media/category-03.3a48c7ce.svg";